import { useState, useEffect } from "react";

// Fallback data if CMS network request is delayed or during offline development
const FALLBACK_GALLERIES = {
  "rottespaerre-galleri": {
    title: "Rottespærre og Rottesikring",
    description: "Montering og inspektion af autoriserede rottespærrer i rustfrit stål i brønde og afløb samt fotodokumentation af rotters færden i kloakrør.",
    images: [
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/rottespaerre-montering.png",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-0472.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-2699.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0301.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0303.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/rottesikring-inspektion.png"
    ]
  },
  "raad-mod-rotter-galleri": {
    title: "Fotodokumentation: Rotter i kloaksystemet",
    description: "Konkrete inspektionsbilleder af rotters færden i kloakrør. Grundig kontrol og rottesikring forebygger skader.",
    images: [
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-0472.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-2699.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0301.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0303.webp"
    ]
  },
  "hoejvandslukke-galleri": {
    title: "Højvandslukke Installation",
    description: "Effektiv sikring mod opstuvning og skybrud med automatiske og manuelle højvandslukkere.",
    images: [
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-flood-header2-scaled.jpg",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/hoejvandslukke-installation.png"
    ]
  },
  "kloak-tv-galleri": {
    title: "Kloak TV Inspektion",
    description: "Moderne TV-inspektion af kloaksystemer med avanceret kameraudstyr for præcis diagnosticering.",
    images: [
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/260304-1146b-survey.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/260304-1146a-survey.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/260304-1152a-survey.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/260304-1143a-survey.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0878.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0890.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/copilot-20260910-085420.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0308.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0301.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/pict0303.webp"
    ]
  },
  "punktreparation-galleri": {
    title: "Punktreparation uden opgravning",
    description: "Reparation af kloakskader uden opgravning ved hjælp af opblæselig packer og partiel foring.",
    images: [
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-punktrep-header-scaled.jpg",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/punktreparation-kloak.png"
    ]
  },
  "firma-galleri": {
    title: "Firma og Udstyr",
    description: "Fyns Afløbsteknik ApS - servicevogne, udstyr og autoriseret kloakmester i arbejde på Fyn.",
    images: [
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-1409.webp",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-7-fynsafloebsteknik2.jpg",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-6-fynsafloebsteknik1.jpg",
      "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-8-fynsafloebsteknik3.jpg"
    ]
  }
};

function getOptimizedImageUrl(url, width = 800) {
  if (!url || typeof url !== "string") return url;
  // Serve directly if it's from materials or already formatted
  if (url.includes("imgi-") || url.includes("fynsafloebsteknik")) {
    return url;
  }
  if (url.includes("assets.auxodev.dk") && !url.includes("/cdn-cgi/image/")) {
    return url.replace("https://assets.auxodev.dk/", `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=85,format=auto/`);
  }
  return url;
}

export default function Gallery({ gallerySlug }) {
  const [galleryData, setGalleryData] = useState(() => FALLBACK_GALLERIES[gallerySlug] || null);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [touchStart, setTouchStart] = useState(null);

  useEffect(() => {
    if (!gallerySlug) return;

    let isMounted = true;
    async function fetchGallery() {
      try {
        // Hent fra det offentlige CMS-endpoint
        const res = await fetch("https://api.dev.auxo.dk/public/content/galleries");
        if (res.ok) {
          const items = await res.json();
          if (Array.isArray(items)) {
            const found = items.find(
              (g) => g.gallery_slug === gallerySlug || g.slug?._ === gallerySlug || g.title === gallerySlug
            );
            if (found && isMounted) {
              setGalleryData({
                title: found.title || "",
                description: found.description || "",
                images: Array.isArray(found.images) ? found.images : []
              });
            }
          }
        }
      } catch {
        // Falder tilbage på eksisterende eller fallback data
      }
    }

    fetchGallery();
    return () => {
      isMounted = false;
    };
  }, [gallerySlug]);

  const images = galleryData?.images || FALLBACK_GALLERIES[gallerySlug]?.images || [];

  // Lightbox keyboard controls
  useEffect(() => {
    if (lightboxIndex === null) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setLightboxIndex(null);
      } else if (e.key === "ArrowRight") {
        setLightboxIndex((prev) => (prev + 1) % images.length);
      } else if (e.key === "ArrowLeft") {
        setLightboxIndex((prev) => (prev - 1 + images.length) % images.length);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [lightboxIndex, images.length]);

  if (!images || images.length === 0) {
    return null;
  }

  // Touch/swipe navigation
  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStart === null) return;
    const touchEnd = e.changedTouches[0].clientX;
    const diff = touchStart - touchEnd;

    if (Math.abs(diff) > 40) {
      if (diff > 0) {
        // Swipe left -> næste
        setLightboxIndex((prev) => (prev + 1) % images.length);
      } else {
        // Swipe right -> forrige
        setLightboxIndex((prev) => (prev - 1 + images.length) % images.length);
      }
    }
    setTouchStart(null);
  };

  return (
    <section className="my-10 pt-6 border-t border-neutral-200">
      <div className="mb-6">
        <span className="text-xs font-bold uppercase tracking-wider text-neutral-500 block mb-1">
          Billedgalleri
        </span>
        <h3 className="text-xl sm:text-2xl font-bold text-neutral-900">
          {galleryData?.title || "Billeder fra arbejdet"}
        </h3>
        {galleryData?.description && (
          <p className="text-sm text-neutral-600 mt-1 max-w-2xl">
            {galleryData.description}
          </p>
        )}
      </div>

      {/* Grid med thumbnails */}
      <div className={`grid gap-4 ${images.length === 1 ? "grid-cols-1 max-w-xl" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"}`}>
        {images.map((imgUrl, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => setLightboxIndex(idx)}
            className="group relative block w-full aspect-4/3 overflow-hidden rounded-lg bg-neutral-900 focus:outline-none focus:ring-2 focus:ring-neutral-400 text-left cursor-pointer"
          >
            <img
              src={getOptimizedImageUrl(imgUrl, 600)}
              alt={`${galleryData?.title || "Galleri"} foto ${idx + 1}`}
              className="w-full h-full object-contain p-1 transition-transform duration-300 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
              <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-black/75 text-white text-xs font-medium px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-lg">
                <i className="fa-solid fa-magnifying-glass-plus" aria-hidden="true" />
                <span>Forstør</span>
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex flex-col items-center justify-center p-4 sm:p-6 select-none animate-in fade-in duration-200"
          onClick={() => setLightboxIndex(null)}
        >
          {/* Top Bar with counter & close */}
          <div
            className="w-full max-w-5xl flex items-center justify-between text-white mb-3"
            onClick={(e) => e.stopPropagation()}
          >
            <span className="text-sm font-medium text-neutral-400">
              Billede {lightboxIndex + 1} af {images.length}
            </span>
            <button
              type="button"
              onClick={() => setLightboxIndex(null)}
              className="p-2 text-neutral-300 hover:text-white rounded-lg hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-white transition-colors"
              aria-label="Luk fuldskærmsvisning"
            >
              <i className="fa-solid fa-xmark text-2xl" aria-hidden="true" />
            </button>
          </div>

          {/* Main Image View with navigation */}
          <div
            className="relative w-full max-w-5xl max-h-[80vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {images.length > 1 && (
              <button
                type="button"
                onClick={() => setLightboxIndex((prev) => (prev - 1 + images.length) % images.length)}
                className="absolute left-2 sm:-left-12 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/70 hover:bg-white hover:text-black text-white flex items-center justify-center text-lg focus:outline-none focus:ring-2 focus:ring-white transition-colors shadow-lg z-10"
                aria-label="Forrige billede"
              >
                <i className="fa-solid fa-chevron-left" aria-hidden="true" />
              </button>
            )}

            <img
              src={getOptimizedImageUrl(images[lightboxIndex], 1400)}
              alt={`${galleryData?.title || "Galleri"} billede ${lightboxIndex + 1}`}
              className="max-h-[75vh] max-w-full object-contain rounded shadow-2xl"
            />

            {images.length > 1 && (
              <button
                type="button"
                onClick={() => setLightboxIndex((prev) => (prev + 1) % images.length)}
                className="absolute right-2 sm:-right-12 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/70 hover:bg-white hover:text-black text-white flex items-center justify-center text-lg focus:outline-none focus:ring-2 focus:ring-white transition-colors shadow-lg z-10"
                aria-label="Næste billede"
              >
                <i className="fa-solid fa-chevron-right" aria-hidden="true" />
              </button>
            )}
          </div>

          {/* Thumbnails preview if multiple */}
          {images.length > 1 && (
            <div
              className="flex items-center gap-2 mt-4 max-w-md overflow-x-auto py-1"
              onClick={(e) => e.stopPropagation()}
            >
              {images.map((thumb, tIdx) => (
                <button
                  key={tIdx}
                  type="button"
                  onClick={() => setLightboxIndex(tIdx)}
                  className={`w-14 h-10 rounded overflow-hidden shrink-0 border-2 transition-all ${
                    tIdx === lightboxIndex ? "border-white scale-105" : "border-transparent opacity-60 hover:opacity-100"
                  }`}
                >
                  <img
                    src={getOptimizedImageUrl(thumb, 120)}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </section>
  );
}
